export default "__VITE_ASSET__beb99813__"